import ReduxHooks from '../../../../store/ReduxHooks';
import { actionCreators } from '../../../../store/actions';

/**
 * The inner printer is a platform fact — only the Sunmi terminals have one. Mirror the reported
 * value instead of only writing `true`: native is the authority, so a `false` has to be able to
 * overwrite the assumption PrintProvider makes for pre-bridge shells, or usePrinter would keep
 * routing receipts to a printer the device does not have.
 */
export default class ConnectInnerPrinterHandler {
  static type = 'CONNECT_INNER_PRINTER';

  payload = null;

  constructor(payload) {
    this.payload = payload;
  }

  notify() {
    ReduxHooks.dispatch(actionCreators.print.setInnerPrinterConnected(!!this.payload?.innerPrinterConnected));
  }
}
